var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPageNotFound404 = function SvgPageNotFound404(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 415.35 193.43"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".page-not-found-404_svg__cls-2{fill:#003865}.page-not-found-404_svg__cls-3{fill:#409dcb}.page-not-found-404_svg__cls-4{fill:#007dba}.page-not-found-404_svg__cls-6{fill:none;stroke:#76e0d2;stroke-linecap:round;stroke-linejoin:round}.page-not-found-404_svg__cls-7{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    id: "page-not-found-404_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "page-not-found-404_svg__ERROR_MESSAGES",
    "data-name": "ERROR MESSAGES"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.27 24.63C347 124.92 232.12 193.43 99.7 193.43A373 373 0 0 1 0 180c101.56-9.82 188.32-70 235.14-155.34z",
    style: {
      fill: "#ce0058"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 115.19,
    height: 170.37,
    x: 166.19,
    y: -16.84,
    className: "page-not-found-404_svg__cls-2",
    rx: 6.81,
    transform: "rotate(90 223.78 68.35)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.5 18.81h156.56v99.07H145.5z",
    className: "page-not-found-404_svg__cls-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.29 117.88h146.77V18.81h-55.6a303.26 303.26 0 0 1-91.17 99.07",
    className: "page-not-found-404_svg__cls-4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M334.54 153.6c-1.17-1.31-21.31-24-22.75-25.4s-4.92-2.35-10.17-2.35H145.94c-5.25 0-8.73 1-10.17 2.35s-21.58 24.09-22.77 25.4.13 2.62 3.49 2.93c5.32.48 209.2.48 214.53 0 3.39-.31 4.68-1.62 3.52-2.93",
    style: {
      fill: "#bfdeee"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.61 154.24v.18a.9.9 0 0 1 .07-.27z",
    className: "page-not-found-404_svg__cls-6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M331.05 156.53c-5.3.47-105.42.22-107.25.21-1.82 0-101.95.26-107.24-.21-2.3-.21-3.63-.89-3.87-1.72l.38 5.4c.24 1.33.13 2.63 3.49 2.93 5.32.48 106 .17 107.26.16s101.94.32 107.27-.16c3.36-.3 3.25-1.6 3.49-2.93l.38-5.4c-.28.83-1.61 1.51-3.91 1.72",
    className: "page-not-found-404_svg__cls-2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M334.88 154.15a1.3 1.3 0 0 1 .06.27v-.18z",
    className: "page-not-found-404_svg__cls-6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M245.05 146.34h-42.9l-2.59 6.61h48.08zM208.81 135.1l-.44 3.16h15.47v-3.16zM190.56 135.1l-1.06 3.16h12.74l.93-3.16zM217.79 130.36l-.34 3.15h6.39v-3.15zM199.56 130.36l-.75 3.15h12.6l.66-3.15zM172.15 135.1l-1.44 3.16h12.64l1.31-3.16zM181.37 130.36l-1.26 3.15h12.46c-.07 0 1.22-3.15 1.22-3.15zM181.97 140.41l-1.2 3.15h43.07v-3.15zM159.38 140.41l-1.52 3.15h15.27l1.43-3.15zM163.47 130.36l-1.71 3.15h12.35l1.49-3.15zM145.15 130.36l-2.41 3.15h12.75l1.94-3.15zM141.53 135.1l-2.41 3.16h24.39l1.83-3.16zM137.47 140.41l-2.41 3.15h16.5l1.91-3.15z",
    className: "page-not-found-404_svg__cls-2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m238.75 135.1.45 3.16h-15.47v-3.16zM257.01 135.1l1.05 3.16h-12.73l-.94-3.16zM229.77 130.36l.34 3.15h-6.38v-3.15zM248.01 130.36l.74 3.15h-12.6l-.65-3.15zM275.42 135.1l1.44 3.16h-12.65l-1.3-3.16zM266.2 130.36l1.26 3.15H255c.06 0-1.22-3.15-1.22-3.15zM265.6 140.41l1.2 3.15h-43.07v-3.15zM288.18 140.41l1.52 3.15h-15.27l-1.42-3.15zM284.09 130.36l1.72 3.15h-12.36l-1.48-3.15zM302.41 130.36l2.41 3.15h-12.75l-1.94-3.15zM306.04 135.1l2.41 3.16h-24.4l-1.82-3.16zM310.09 140.41l2.41 3.15h-16.49l-1.92-3.15z",
    className: "page-not-found-404_svg__cls-2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M357.87 110.14h11.53L411.54 153l.19 13-6.74.12-10.78-.12-37.89-41.82z",
    className: "page-not-found-404_svg__cls-3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m411.76 148.63-37.93-37.92a12.2 12.2 0 0 0-8.7-3.61 12.4 12.4 0 0 0-2.28.23 66 66 0 1 0-9.8 9.8 12.27 12.27 0 0 0 3.38 11L394.36 166a12.3 12.3 0 0 0 17.4-17.4zM251.55 65.92A60.09 60.09 0 1 1 311.64 126a60.15 60.15 0 0 1-60.09-60.08m156.09 86.83a6.49 6.49 0 0 1 0 9.16 6.63 6.63 0 0 1-9.16 0L360.55 124a6.49 6.49 0 0 1 0-9.16 6.63 6.63 0 0 1 9.16 0",
    className: "page-not-found-404_svg__cls-2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M251.55 65.92A60.09 60.09 0 1 1 311.64 126a60.15 60.15 0 0 1-60.09-60.08",
    className: "page-not-found-404_svg__cls-7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M311.64 120a54.09 54.09 0 1 1 54.09-54.09A54.15 54.15 0 0 1 311.64 120",
    className: "page-not-found-404_svg__cls-4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m304.72 63 .5-.5c12.7-.4 18.5-4.5 18.5-11.1v-.2c0-5.6-4.3-9.5-11.5-9.5-6.3 0-11.5 2.8-16.3 7.9l-7.5-8c5.8-6.6 13.3-11.1 24.1-11.1 14 0 23.5 7.8 23.5 20.3v.2c0 12.6-9.1 18.3-20.2 20.2l-1 8h-8.1zm-.9 24.6h13.4v13.8h-13.4z",
    className: "page-not-found-404_svg__cls-7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231.8 109.69h-58.78V25.64h33.62l25.16 25.15z",
    style: {
      strokeWidth: 3,
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.25 50.79h-25.16V25.64",
    style: {
      strokeWidth: 2,
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }))));
};
export default SvgPageNotFound404;